<template>
  <div class="container-fluid">
    <el-table
      class="table-responsive align-items-center table-flush"
      header-row-class-name="thead-light"
      :data="invoices"
      v-loading="loading"
    >
      <div slot="empty" class="text-center text-muted py-4">
        {{ $t("COMMON.NO_DATA") }}
      </div>

      <el-table-column :label="$t('COMMON.NUMBER')" min-width="160">
        <template v-slot="{ row }">
          <a class="text-primary" style="cursor: pointer" @click="viewInvoice(row)">
            {{ row.seq_number || row.code || row.id }}
          </a>
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('ESTABLISHMENT_INTERNAL_INVOICES.INTERNAL_INVOICE_DATE')"
        min-width="140"
      >
        <template v-slot="{ row }">
          {{ row.transfer_date ? $formatDate(row.transfer_date, "LL") : "-" }}
        </template>
      </el-table-column>

      <el-table-column :label="$t('COMMON.STATUS')" min-width="120">
        <template v-slot="{ row }">
          <establishment-internal-invoice-status-badge :transfer="row" />
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('ESTABLISHMENT_INTERNAL_INVOICES.ACCEPTED_AT')"
        min-width="160"
      >
        <template v-slot="{ row }">
          {{ row.accepted_at ? $timeZoneDateFormat(row.accepted_at) : "-" }}
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('COMMON.TOTAL')"
        min-width="120"
        class-name="number-column"
        label-class-name="number-column"
      >
        <template v-slot="{ row }">
          {{ $formatCurrency(row.pricing ? row.pricing.total || 0 : 0) }}
        </template>
      </el-table-column>
    </el-table>

    <div class="row mt-3" v-if="invoices.length">
      <div class="col-6"></div>
      <div class="col-6">
        <dl class="row mb-0">
          <dt class="col-sm-6">
            {{ $t("ESTABLISHMENT_INTERNAL_ORDERS.INVOICED") }}
          </dt>
          <dd class="col-sm-6 text-right px-0">
            {{ $formatCurrency(acceptedTotal) }}
          </dd>
        </dl>
        <dl class="row mb-0">
          <dt class="col-sm-6">{{ $t("ESTABLISHMENT_INTERNAL_ORDERS.ORDERED") }}</dt>
          <dd class="col-sm-6 text-right px-0">
            {{ $formatCurrency(order.pricing ? order.pricing.total || 0 : 0) }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import EstablishmentInternalInvoiceStatusBadge from "@/views/Pages/InventoryModule/EstablishmentInternalInvoiceManagement/partials/EstablishmentInternalInvoiceStatusBadge.vue";
import { ESTABLISHMENT_INTERNAL_INVOICE_STATUS_ACCEPTED } from "@/constants/establishmentInternalInvoices";

export default {
  name: "establishment-internal-order-view-invoices",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    EstablishmentInternalInvoiceStatusBadge,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      invoices: [],
      loading: false,
    };
  },
  computed: {
    /**
     * Only ACCEPTED invoices are accounted for in the weekly reports, so that is
     * the figure to compare with what was ordered.
     */
    acceptedTotal() {
      return this.invoices
        .filter(
          (invoice) => invoice.status === ESTABLISHMENT_INTERNAL_INVOICE_STATUS_ACCEPTED
        )
        .reduce(
          (carry, invoice) => carry + parseFloat(invoice.pricing?.total || 0),
          0
        );
    },
  },
  created() {
    this.getInvoices();
  },
  watch: {
    "order.id": {
      handler() {
        this.getInvoices();
      },
    },
  },
  methods: {
    async getInvoices() {
      if (!this.order.id) return;
      this.loading = true;
      try {
        await this.$store.dispatch("establishmentInternalInvoices/list", {
          filter: { internal_order: this.order.id },
          sort: "transfer_date",
          page: { number: 1, size: 100 },
        });
        this.invoices = this.$store.getters["establishmentInternalInvoices/list"] || [];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.loading = false;
      }
    },
    viewInvoice(invoice) {
      this.$router.push({
        name: "View EstablishmentInternalInvoice",
        params: { id: invoice.id },
      });
    },
  },
};
</script>
